<template>
    <div class="inputs">
        <div class="input input-container">
            <label>{{ $t("settings.phoneNumber") }}</label>
            <VuePhoneNumberInput
                v-model="phoneNumber"
                :default-country-code="country"
                no-flags
                @update="handlePhoneUpdate"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import log2 from "../../../../utils/log2";

Vue.component("VuePhoneNumberInput", VuePhoneNumberInput);
const log = log2("PhoneActionForm");
log("VuePhoneNumberInput", VuePhoneNumberInput);
export default {
    name: "PhoneActionForm",
    props: {
        value: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        const phoneNumber = this.value.tel ? `+${this.value.callingCode}${this.value.tel}` : "";
        const country = (this.value.country || "TR").toUpperCase();
        return {
            phoneNumber: phoneNumber,
            country,
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        handlePhoneUpdate(e) {
            log("handlePhoneUpdate", e);
            const { countryCallingCode, nationalNumber, countryCode } = e;
            this.clone.callingCode = countryCallingCode;
            this.clone.tel = nationalNumber;
            this.clone.country = countryCode;
        },
    },
    watch: {
        clone: {
            handler(val) {
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
.inputs {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .input-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
        position: relative;

        label {
            font-size: 12px;
            color: var(--color-text-strong-default);
        }

        input {
            border: 1px solid var(--color-border-default);
            border-radius: 5px;
            padding: 5px 10px;
            flex: 1;
            outline: none;

            &:focus {
                border: 1px solid #1999e3;
                box-shadow: 0 0 0 2px rgba(25, 153, 227, 0.2);
            }

            &.error {
                border: 1px solid red;
                box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.2);
            }
        }

        .input-cancel-icon {
            cursor: pointer;
            position: absolute;
            top: 50%;
            right: 5px;
            font-size: 16px;
            transform: translateY(-50%);
        }
    }
}
</style>
